var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTableDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "chevron-down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.91009 6.91075C4.23553 6.58531 4.76317 6.58531 5.0886 6.91075L10.3327 12.1548L15.5768 6.91075C15.9022 6.58531 16.4298 6.58531 16.7553 6.91075C17.0807 7.23619 17.0807 7.76382 16.7553 8.08926L10.9219 13.9226C10.5965 14.248 10.0689 14.248 9.74343 13.9226L3.91009 8.08926C3.58466 7.76382 3.58466 7.23619 3.91009 6.91075Z",
    fill: "#666666"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTableDown);
export default __webpack_public_path__ + "static/media/table_down.2639935a102f86b4ac8bedc5ea2b9ac3.svg";
export { ForwardRef as ReactComponent };